import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { TextField } from 'redux-form-material-ui'
import { RaisedButton } from 'material-ui'
import { login, clearLoginError } from '../actions'
import { Row, Col } from 'pui-react-grids'
import { required } from '../form/validation'
import { themeColors } from '../styles/theme'
import FontIcon from 'material-ui/FontIcon'

const styles = {
  loginForm: {
    backgroundColor: 'rgb(255, 255, 255)',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    boxSizing: 'border-box',
    // -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
    borderRadius: '2px',
    zIndex: 1,
    padding: '20px',
    maxWidth: '500px',
    margin: 'auto',
  },
  welcomeCol: {
    margin: 0,
    textAlign: 'center',
    height: '100%',
    paddingBottom: '40px',
  },
  welcomeText: {
    color: '#424242',
    fontSize: '12px',
    lineHeight: '9px',
  },
  welcomeLink: {
    color: 'rgb(0 ,188, 212)',
    paddingLeft: '4px',
    paddingRight: '4px',
    borderRadius: '2px',
  },
  logo: {
    width: '170px',
    height: 'auto',
    marginBottom: '30px',
    marginTop: 10,
  },
  errorMessage: {
    padding: 10,
    fontWeight: 'bold',
    color: themeColors.secondary,
    backgroundColor: themeColors.lightBackground,
    borderRadius: 4,
    margin: 10,
  },
  errorIcon: {
    position: 'relative',
    top: 5,
    right: 4,
    color: themeColors.secondary,
  },
  facebookBtn: {
    marginTop: 10,
  },
}

class Login extends PureComponent {
  componentWillUnmount() {
    this.props.clearLoginError()
  }

  render() {
    const { handleSubmit, auth: { loginError, loginLoading } } = this.props

    return (
      <div style={{ minHeight: '100vh' }}>
        <Row style={{ marginLeft: 0, marginRight: 0 }}>
          <Col md={24} style={styles.welcomeCol}>
            <div style={styles.loginForm}>
              <h2 style={{ marginBottom: 0, paddingBottom: 0 }}>Benvenuto</h2>
              <form
                className="login-form"
                onSubmit={handleSubmit(this.props.login)}>
                <div>
                  <Field
                    name="username"
                    component={TextField}
                    hintText="Username"
                    floatingLabelText="Username o indirizzo mail"
                    validate={required}
                    className="LoginInput"
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                  />
                </div>
                <div>
                  <Field
                    name="password"
                    component={TextField}
                    type="password"
                    hintText="Password"
                    floatingLabelText="Password"
                    validate={required}
                    className="LoginInput"
                  />
                </div>
                <div>
                  <RaisedButton
                    label="Login"
                    type="submit"
                    disabled={loginLoading}
                    style={{ marginTop: '40px' }}
                    primary={true}
                  />
                </div>
                <div>
                  <RaisedButton
                    disabled={loginLoading}
                    onClick={() => this.props.login({ fb: true })}
                    type="button"
                    label="Login con facebook"
                    backgroundColor="#3B5998"
                    style={styles.facebookBtn}
                    labelColor={themeColors.white}
                    icon={
                      <FontIcon
                        className="fa fa-facebook"
                        style={{ color: themeColors.white }}
                      />
                    }
                  />
                </div>
                {loginError &&
                  <div style={styles.errorMessage}>
                    <FontIcon
                      style={styles.errorIcon}
                      className="material-icons">
                      report_problem
                    </FontIcon>
                    Credenziali errate
                  </div>}
              </form>
              <p style={styles.welcomeText}>
                Non hai ancora un account?
                {' '}
                <Link to="/register" style={styles.welcomeLink}>
                  Registrati
                </Link>
              </p>
              <p style={styles.welcomeText}>
                Hai dimenticato la password?
                {' '}
                <Link to="/password-recover" style={styles.welcomeLink}>
                  Recupera Password
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default reduxForm({
  form: 'login',
})(
  connect(({ auth }) => ({ auth }), {
    login,
    clearLoginError,
  })(Login)
)



// WEBPACK FOOTER //
// ./src/pages/Login.js